import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import {PickList} from 'primereact/picklist';

import servicioPerfil from '../servicios/ServicioPerfil';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioFuncionalidad from '../servicios/ServicioFuncionalidad';


export class Perfil extends Component {

  constructor() {
    super();
    this.state = {
      perfil:{},
      paginacion: { registrosPorPagina: 10},
      inicio: 0,
      modalPerfil:false,
      erroresPerfil:{},
      modalConfirmacion:false,
      todosPermisos: [],
      permisosAsignados: []
    }
  }

  componentDidMount() {
    this.obtener_pagina();
  }

  cambiar_pagina = (event) => {
    let { paginacion } = this.state;

    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    this.setState({ inicio: event.first, paginacion });
    this.obtener_pagina();
  }

  obtener_pagina() {
    let { paginacion } = this.state;
    servicioPerfil.paginacion(paginacion).then((response) => {
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

      this.setState({ paginacion: response.data.objeto });


    }).catch((error) => {
      if (error)
        return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
    });

  }

  nuevo_perfil=()=>{
    let paginacion= { registrosPorPagina: 500};
    servicioFuncionalidad.paginacion(paginacion).then(response => {   
      let todosLosPermisos=response.data.objeto.datos;  
        let losPermisosAsignados=[];        
        this.setState({
          perfil: {},
          modalPerfil:true,
          todosPermisos: todosLosPermisos,
          permisosAsignados: losPermisosAsignados
        });      
    }).catch(error => {

    });    
  }

  columna_editar = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi-md-edit" className="p-button-success" name="editar"
        tooltip="editar" onClick={(e)=>this.pre_editar_perfil(column.rowData)}>
      </Button>
    </div>;
  }

  pre_editar_perfil=(objeto)=>{
    let  paginacion= { registrosPorPagina: 500 }
    servicioFuncionalidad.paginacion(paginacion).then(response => {
      let todosLosPermisos=response.data.objeto.datos;
      servicioPerfil.busqueda_perfil_funcionalidad({ id: objeto.id }).then(resfuncionalidad => {
        let losPermisosAsignados=resfuncionalidad.data.objeto.tcFuncionalidads;
        for (let index = 0; index < losPermisosAsignados.length; index++) {
          let elementoBuscar=todosLosPermisos.find(permiso => permiso.id === losPermisosAsignados[index].id);
          if(undefined !== elementoBuscar){
            servicioAsignacionValoresObjetos.eliminarObjetoMapa(todosLosPermisos,elementoBuscar);
           }
        }
        this.setState({
          perfil: objeto,
          modalPerfil:true,
          todosPermisos: todosLosPermisos,
          permisosAsignados: losPermisosAsignados
        });
      })
    
    });

     
  }

  columna_eliminar = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi-md-delete" className="p-button-warning" name="eliminar"
        tooltip="eliminar" onClick={(e)=> this.pre_eliminar(column.rowData)} >
      </Button>
    </div>;
  }

  pre_eliminar=(objeto)=>{
    this.setState({modalConfirmacion:true,perfil:objeto});
  }

  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }

  cerrar_modal_perfil=()=>{
      this.setState({modalPerfil:false,perfil:{}});
  }

  guardar_perfil=()=>{
    let {perfil,permisosAsignados}=this.state;
    let erorres = this.validar_formulario(perfil);
    this.setState({ erroresPerfil: erorres });
    if (!Object.keys(erorres).length) {
      perfil['tcFuncionalidads'] = permisosAsignados;
      servicioPerfil.guardar(perfil).then(response=>{
        this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        this.setState({ perfil: {}, modalPerfil: false, erroresPerfil: {} });
            this.obtener_pagina();
      });
    }

  }

  validar_formulario=(perfil)=>{
    const erroresRequeridos = {};

    if (!perfil.nombre) {
      erroresRequeridos.nombre = "El nombre es requerido";
    }
    if (!perfil.rol) {
      erroresRequeridos.rol = "EL rol es requerido";
    }
    return erroresRequeridos;
  }

  cerrar_modal_confirmacion=()=>{
    this.setState({modalConfirmacion:false,perfil:{}});
  }

  eliminar_perfil=()=>{
    let {perfil}=this.state;
    servicioPerfil.eliminar(perfil).then(response=>{
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        this.setState({ perfil: {}, modalConfirmacion: false, erroresPerfil: {} });
        this.obtener_pagina();
    })
  }

  buscar_like=()=>{
    let {perfil,paginacion}=this.state;
    servicioPerfil.busqueda_like(perfil).then(response=>{
      if (response.data.lista.length === 0) {
        this.growl.show({ life: 6000, severity: 'error', summary: '', detail: 'No existe informaci\u00f3n con los valores ingresados, verifica tus datos' });
        paginacion['datos'] = response.data.lista;
        this.setState({ paginacion });
      } else {
        this.growl.show({ life: 1000, severity: 'success', summary: '', detail: "Valores encontrados" });
        paginacion['datos'] = response.data.lista;
        this.setState({paginacion });
      }
    })
  }

  plantillaPermiso = (permiso) => {
    return (
      <div className="p-clearfix">
        <div style={{ fontSize: '14px', float: 'center', margin: '15px 5px 0 0' }}>{permiso.nombre}</div>
      </div>
    );
  }

  asignacionPermisos = (event) => {    
    this.setState({
      todosPermisos: event.source,
      permisosAsignados: event.target
    });
  }

  render() {
    let {perfil,paginacion,inicio,erroresPerfil,permisosAsignados,todosPermisos}=this.state;

    let dialogFooterPerfil= (
      <div>
        <Button icon="pi-md-check" onClick={this.guardar_perfil} label="Guardar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrar_modal_perfil} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    let dialogFooterConfirmacion = (
      <div>
        <Button icon="pi-md-check" onClick={this.eliminar_perfil} label="Si estoy seguro" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrar_modal_confirmacion} label="No estoy seguro" className="p-button-danger flat-btn" />
      </div>
    );

    return (
    <div>
      <Growl ref={(el) => this.growl = el} />


      <div className="card card-w-title">
        <h1 style={{marginBottom:'30px'}}>Administración de Perfil</h1>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
            <Button type="button" className="blue-grey-btn flat-btn" label="Nuevo Perfil" name="nuevo" value="Nuevo"
              tooltip="Nuevo perfil" onClick={this.nuevo_perfil} >
            </Button>
          </div>
        </div>
      </div>

      <div className="card card-w-title">
        <div className="p-grid p-fluid">
          <div className="p-col-12">
            <div className="p-col-12" style={{fontWeight:'bold', marginLeft:'5px'}}>
              <label htmlFor="buscar">Buscar Perfil:</label>
            </div>
            <div className="p-col-12 p-md-6" style={{marginLeft:'5px'}}>
              <InputText className="p-inputtext" placeholder="Escribe el nombre o rol del perfil" name="perfil.busquedaLike" value={perfil.busquedaLike || ''} onChange={this.asignarValoresObjeto} onKeyUp={this.buscar_like} />
            </div>
          </div>
        </div>

      </div>
    
      <div className="p-grid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <DataTable value={paginacion.datos} responsive={true} header="MIS PERFILES">
              <Column field="nombre" header="Nombre" autoLayout={true} style={{textAlign:'center'}}/>
              <Column field="rol" header="ROL" autoLayout={true} style={{textAlign:'center'}}/>
              <Column header="Editar" body={this.columna_editar} style={{textAlign:'center'}}/>
              <Column header="Eliminar" body={this.columna_eliminar} style={{textAlign:'center'}}/>
            </DataTable>
            <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiar_pagina.bind(this)} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} />
          </div>
        </div>
      </div>

      <Dialog header="Perfil, los campos con * son requeridos." visible={this.state.modalPerfil} modal={true} footer={dialogFooterPerfil} onHide={this.cerrar_modal_perfil}>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-2">
            <label htmlFor="nombre">* Nombre:</label>
          </div>
          <div className="p-col-12 p-md-4">
          <InputText name="perfil.nombre" value={perfil.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresPerfil.nombre ? 'p-error' : ''} />
            {erroresPerfil.nombre ? <div> <Message severity="error" text={erroresPerfil.nombre} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-2">
            <label htmlFor="numero">* Rol:</label>
          </div>
          <div className="p-col-12 p-md-4">
          <InputText name="perfil.rol" value={perfil.rol || ''} onChange={this.asignarValoresObjeto} className={erroresPerfil.rol ? 'p-error' : ''} />
            {erroresPerfil.rol ? <div> <Message severity="error" text={erroresPerfil.rol} /> </div> : null}
          </div>

          <div className="p-col-12">
          <PickList source={todosPermisos} showSourceControls={false} showTargetControls={false} target={permisosAsignados} itemTemplate={this.plantillaPermiso}
            sourceHeader="Permisos disponibles" targetHeader="Permisos asignados" responsive={true}
            sourceStyle={{ height: '300px' }} targetStyle={{ height: '300px' }}
            onChange={this.asignacionPermisos}></PickList>
          
          </div>
        </div>



      </Dialog>

      <Dialog header="Confirmación" visible={this.state.modalConfirmacion} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacion} onHide={this.cerrar_modal_confirmacion}>
        <h2>¿Estás seguro de eliminar el Perfil ?</h2>
      </Dialog>

    
    </div>);
  }


}